import React from 'react';
import { t } from 'i18next';
import { CHECKED, UNCHECKED } from 'icons';

const FilterOption = ({ option, isSelected, onToggle }) => {
    return (
        <li className="flex items-center gap-2 text-16x py-2 shadow-sm" onClick={onToggle}>
            <span className="w-6 h-6 inline-flex">
                {isSelected ? <CHECKED /> : <UNCHECKED />}
            </span>
            <span className={isSelected ? "font-bold" : ""}>
                {option?.symbol} {t(option?.name)}
            </span>
        </li>
    );
};

export default FilterOption;
